'use client';

// ─────────────────────────────────────────────────────────────────────────────
// InspectionsTab — full QC daily route: map, inspection cards, drawer for
// detail + photo capture + chat. The QC Escalations panel has moved to
// the Tickets tab (merged with PM Escalations under one unified list with
// a source tag); QCInspectionPanel itself still owns the qc_escalations
// fetch but no longer renders that section here — see the panel for the
// passthrough.
//
// Clock-in lives on the Today tab (ClockInBar). The inspector clocks in
// once per day and then comes here to do the actual rounds.
// ─────────────────────────────────────────────────────────────────────────────

import QCInspectionPanel from '../QCInspectionPanel';

export default function InspectionsTab() {
  return <QCInspectionPanel />;
}
